import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import { Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../reducers';
import './BreadCrumbs.scss';
import { ReactComponent as IconForward } from '../../assets/icons/forward.svg';
import * as actions from '../../actions/index';
import { isProd, isStage } from '../../constants/config';
import { getHomeHref } from '../../utils/homeLink';

interface Props {
  locales: any;
  intl: any;
  userData: any;
  history: any;
  pageName?: string;
  logOut: any;
  keycloak: any;
  parentPage?: string;
  secondLevelLabel?: React.ReactNode;
}

const BreadCrumbs = ({ intl, parentPage, pageName, secondLevelLabel }: Props) => {
  const homeLink = (
    <li>
      <a className='color-red pointer' style={{ fontSize: 'inherit' }} href={getHomeHref(intl)}>
        <FormattedMessage id='ec.navigation.homepage' defaultMessage='Home' />
      </a>
    </li>
  );

  if (process.env.REACT_APP_MODE !== 'django') {
    return (
      <div className='breadCrumbsContainer'>
        <div className='djangoContainer'>
          <ul>
            {homeLink}

            <div className='iconWrapper small fillGrey lh2'>
              <IconForward />
            </div>

            <li>{secondLevelLabel ?? <FormattedMessage id='ec.navigation.easy' defaultMessage='Online buchen' />}</li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className='breadCrumbsContainer'>
      <div className='djangoContainer'>
        <ul>
          {homeLink}

          <div className='iconWrapper small fillGrey lh2'>
            <IconForward />
          </div>

          <li>
            <a
              className='color-text pointer'
              style={{ fontSize: 'inherit' }}
              href={
                isProd
                  ? intl.formatMessage({
                      id: 'ec.dashboardService.boxBookingProdLinkSecondLevel',
                      defaultMessage: 'https://www.apgsga.ch/de/aussenwerbung/',
                    })
                  : isStage
                    ? intl.formatMessage({
                        id: 'ec.dashboardService.boxBookingStageLinkSecondLevel',
                        defaultMessage:
                          'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
                      })
                    : intl.formatMessage({
                        id: 'ec.dashboardService.boxBookingDevLinkSecondLevel',
                        defaultMessage: 'https://www.apgsga.ch/de/aussenwerbung/',
                      })
              }
            >
              <FormattedMessage id='ec.navigation.werbekampagne' defaultMessage='Aussenwerbung buchen' />
            </a>
          </li>

          {parentPage && (
            <>
              <div className='iconWrapper small fillGrey lh2'>
                <IconForward />
              </div>

              <li>{parentPage}</li>
            </>
          )}

          {pageName && (
            <>
              <div className='iconWrapper small fillGrey lh2'>
                <IconForward />
              </div>

              <li>{pageName}</li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    logOut: () => dispatch(actions.logOut()),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(BreadCrumbs)));
